export default __webpack_public_path__ + "static/media/ramble.e0009bb1.svg";